import { useState, useCallback } from 'react';
import * as R from 'ramda';
import { Map } from '../../language/models';


/**
 * Use this to store a collection of unique local data values as a map.
 *
 * @param initialMap - the initial state data
 * @returns a getter for the map, a function to add an element to the map, and a function to remove an element from the
 * map
 */
export const useMap = <T extends {}>(
  initialMap: Map<T>,
): [Map<T>, (key: string, value: T) => void, (key: string) => void] => {
  const [map, setMap] = useState<Map<T>>(initialMap);

  const addElement = useCallback(
    (key: string, value: T) => setMap(m => R.assoc(key, value, m)),
    [],
  );

  const removeElement = useCallback(
    (key: string) => setMap(m => R.dissoc(key, m)),
    [],
  );

  return [map, addElement, removeElement];
};
